import colors from 'assets/styles/colors';

import type { IIconProps } from 'infrastructure/interfaces';

const ChevronBottom = ({ color = colors.textColor, ...props }: IIconProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7652 3.48483C10.9116 3.63128 10.9116 3.86872 10.7652 4.01517L6.26517 8.51517C6.11872 8.66161 5.88128 8.66161 5.73484 8.51517L1.23484 4.01516C1.08839 3.86872 1.08839 3.63128 1.23484 3.48483C1.38128 3.33839 1.61872 3.33839 1.76517 3.48483L6 7.71967L10.2348 3.48483C10.3813 3.33839 10.6187 3.33839 10.7652 3.48483Z"
      fill={color}
    />
  </svg>
);

export default ChevronBottom;
